import AbilityDescription from './model';

export default AbilityDescription;



// WEBPACK FOOTER //
// ./data/ProgressTests/Skills/SubSkills/AbilityDescriptions/index.js